/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ISubscriptionPreferencesApi {
    updateSubscriptionPreferences(request: UpdateSubscriptionPreferenceRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_SubscriptionPreferencesApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_SubscriptionPreferencesApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class SubscriptionPreferencesApi implements ISubscriptionPreferencesApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_SubscriptionPreferencesApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_SubscriptionPreferencesApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    updateSubscriptionPreferences(request: UpdateSubscriptionPreferenceRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/app/api/SubscriptionPreferences/updatePreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<FileResponse>(options_);
    }
}

export interface UpdateSubscriptionPreferenceRequest {
    email: string;
    tenantId: string;
    currentPartitionId?: string | undefined;
    subscriptionPreferences: string[];
    messageData?: string | undefined;
    signature?: string | undefined;
}

export type FileResponse = Blob;
